import { render, staticRenderFns } from "./ProductGroups.vue?vue&type=template&id=6261b808"
import script from "./ProductGroups.vue?vue&type=script&lang=js"
export * from "./ProductGroups.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports